import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type PinLocationIconProps = CommonSvgProps

const PinLocationIcon: React.FC<PinLocationIconProps> = React.forwardRef<
  SVGSVGElement,
  PinLocationIconProps
>((props, ref) => (
  <Svg viewBox="0 0 74 44" {...props} ref={ref} color="none">
    <rect x="2" y="13" width="70" height="29" stroke="#51565C" strokeWidth="3" />
    <rect x="29" y="8" width="16" height="10" fill="#7BB835" />
    <path
      d="M37 2C34.0837 2.00344 31.2878 3.16347 29.2256 5.22563C27.1635 7.28778 26.0035 10.0837 26 13C25.9965 15.3832 26.775 17.7018 28.216 19.6C28.216 19.6 28.516 19.995 28.565 20.052L37 30L45.439 20.047C45.483 19.994 45.784 19.6 45.784 19.6L45.785 19.597C47.2253 17.6996 48.0034 15.3821 48 13C47.9966 10.0837 46.8365 7.28778 44.7744 5.22563C42.7122 3.16347 39.9163 2.00344 37 2V2ZM37 17C36.2089 17 35.4355 16.7654 34.7777 16.3259C34.1199 15.8864 33.6072 15.2616 33.3045 14.5307C33.0017 13.7998 32.9225 12.9956 33.0769 12.2196C33.2312 11.4437 33.6122 10.731 34.1716 10.1716C34.731 9.61216 35.4437 9.2312 36.2197 9.07686C36.9956 8.92252 37.7998 9.00173 38.5307 9.30448C39.2616 9.60723 39.8864 10.1199 40.3259 10.7777C40.7654 11.4355 41 12.2089 41 13C40.9987 14.0605 40.5768 15.0771 39.827 15.827C39.0771 16.5768 38.0605 16.9987 37 17V17Z"
      fill="#51565C"
    />
    <line
      x1="18.5"
      y1="32.5"
      x2="56.5"
      y2="32.5"
      stroke="#51565C"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </Svg>
))

PinLocationIcon.propTypes = commonPropTypes
PinLocationIcon.defaultProps = commonDefaultProps

export default PinLocationIcon
